import { useEffect } from 'react';
import { getCurrentAIScribe } from 'store/clients/clientsActions';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import transcribedScreenImage from 'assets/png/aiScribeBackground.png';

import { AiScribeDrawer } from './drawer';

const AiScribe = () => {
  const dispatch = useAppDispatch();
  const { state } = useAppSelector((s) => s.clients.aiScribe);

  useEffect(() => {
    dispatch(getCurrentAIScribe());

    // Preload transcribed screen image
    const img = new Image();
    img.src = transcribedScreenImage;
  }, []);

  if (state == null) return null;

  return <AiScribeDrawer />;
};

export default AiScribe;
